import { yo } from 'models/CommentedAnswer';
import Form from './Form';

export interface IEvaluationProjectJson {
  [key: string]: string;
}

class Evaluation extends Form {
  jsonCustomObsObj: IEvaluationProjectJson = {};
  jsonCustomObs?: string;
  name?: string;
  projectDescribe?: string;
  responsable?: string;
  processingOfPersonalData?: yo = '';
  sensitivePersonalDataSources?: string;
  processingOfSensitivePersonalData?: string;
  focusProcessingPersonalDataOfVulnerable?: yo = '';
  handlingCriminalRecords?: yo = '';
  legalBase?: string;
  legalBaseDataSources?: string;
  projectPurposesAreClear?: string;
  projectWillBeUsedForOtherPurposes?: string;
  creationOfProfilesOfIndividuals?: string;
  combinesMultipleSourcesOfPersonalData?: string;
  largeScaleProcessingOfPersonalData?: string;
  personalDataUsedAreMinimumNecessaryAchievePurposes?: string;
  personalDataCollectedForPurposesOfProject?: string;
  directlyFromTheIndividual?: string;
  sendingDataAbroad?: string;
  innovativeTechnology?: string;
  automatedDecision?: string;
  monitoringTndividuals?: string;
  involvesDataProcessingByThirdParties?: string;
  specificDemand?: string;
  appropriateInformationSecurityMeasures?: string;
  appropriateInformationSecurityMeasuresInformation?: string;
  impactsIndividualsWhomDataReferKnown?: string;
  preventIndividualFromExercisingAnyRight?: string;
  impactHealthOrSafetyOfIndividuals?: string;
  demandID?: string;
}

export default Evaluation;

export interface IEvaluationProjectRecomendations {
  abroad?: IEvaluationProjectDefault;
  thirtyParties?: IEvaluationProjectDefault;
  legalBase?: IEvaluationProjectDefault;
  securityMeasure?: IEvaluationProjectDefault;
  personalData?: IEvaluationProjectDefault;
  retentionData?: IEvaluationProjectDefault;
}
export interface IEvaluationProjectDefault {
  color: string;
  message: string;
}

export interface IEvaluationProjectCompleto {
  recomendations: IEvaluationProjectRecomendations;
  risk: IEvaluationProjectDefault;
  status: string;
  sensitivePersonalDataSources: string;
  legalBaseDataSources: string;
  jsonCustomObs: any;
  jsonCustomObsObj: any;
  // completed: boolean;
  demandID?: any;
  completed?: boolean;
}

export interface IFormProjectFinishPosition {
  idForm: number;
  numberPositionForm: number;
}
